import Page from "../common/page/Page"
import style from "./Policies.module.css"

const RefundPolicy = () => {
  return (
    <Page title="Refund Policy" searchDisabled={true}>
      <div className={style.policyContainer}>
        {/* Luxury Hero Banner */}
        <div className={style.heroHeader}>
          <h1>Refund & Return Policy</h1>
          <p className={style.heroSubtitle}>
            Our guidelines regarding order cancellations, returns, and refunds.
          </p>
        </div>

        {/* Content Card */}
        <div className={style.sectionCard}>
          <h2>Refund Policy</h2>

          <h3>Returns</h3>
          <p>
            As our products come under Health and Personal Care items, these
            products you purchase from us will not be returnable.
          </p>

          <h3>Refunds (if applicable)</h3>
          <p>
            We only accept refunds for missing items in the courier bag, requiring
            an opening video without cuts or pauses for verification. Only
            genuine, unedited courier opening videos will be accepted. If your
            claim is approved, your refund will be processed, and a credit will
            automatically be applied to your credit card or original method of
            payment within a certain number of days.
          </p>

          <h3>Late or Missing Refunds (if applicable)</h3>
          <p>If you haven’t received a refund yet, please follow these steps:</p>
          <ul>
            <li>Check your bank account again.</li>
            <li>
              Contact your credit card company, as it may take some time before
              your refund is officially posted.
            </li>
            <li>
              Contact your bank. There is often some processing time before a
              refund is posted.
            </li>
          </ul>
          <p>
            If you’ve done all of this and you still have not received your refund
            yet, please contact us at{" "}
            <a href="mailto:dr.mmherbalsenquiry@gmail.com">
              dr.mmherbalsenquiry@gmail.com
            </a>
            .
          </p>

          <h3>Sale Items (if applicable)</h3>
          <p>
            Only regular priced items may be refunded. Unfortunately, sale items
            cannot be refunded.
          </p>

          <h3>Exchanges (if applicable)</h3>
          <p>
            Exchanges are available only if you receive a wrong item. You must
            inform us within 24 hours of delivery to be eligible.
          </p>

          <h3>Shipping</h3>
          <p>
            You will be responsible for paying for your own shipping costs for
            returning your item for exchange. Shipping costs are non-refundable.
          </p>
          <p>
            Depending on where you live, the time it may take for your exchanged
            product to reach you may vary.
          </p>
        </div>
      </div>
    </Page>
  )
}

export default RefundPolicy
